import 'bulma/css/bulma.css';
import '@fortawesome/fontawesome-free/js/all';

import { useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';

import Layout from './components/comun/Layout';
import ProtectedRoute from './components/comun/ProtectedRoute';
import Club from './pages/Club';
import Configuracion from './pages/Configuracion';
import Equipo from './pages/Equipo';
import ExplorarLigas from './pages/ExplorarLigas';
import Home from './pages/Home';
import InicioSesion from './pages/InicioSesion';
import Jugador from './pages/Jugador';
import Liga from './pages/Liga';
import Lista from './pages/Lista';
import Partido from './pages/Partido';
import { ContextProvider } from './service/Context';

/**
 * Componente principal de la aplicacion.
 */
function App() {
  useEffect(() => {
    document.title = 'InteliScouting';
  }, []);

  return (
    // eslint-disable-next-line camelcase
    <Router future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
      <ContextProvider>
        <Routes>
          <Route exact path={'/iniciosesion'} element={<InicioSesion />} />

          {/* Shell persistente con Header permanente para todas las rutas protegidas */}
          <Route
            element={
              <ProtectedRoute>
                <Layout />
              </ProtectedRoute>
            }
          >
            <Route exact path={'/'} element={<Home />} />
            <Route path={'/home'} element={<Home />} />
            <Route path={'/scouting'} element={<Home />} />
            <Route path={'/liga/:routeIdLiga?'} element={<Liga />} />
            <Route path={'/jugador/:routeIdJugador?'} element={<Jugador />} />
            <Route path={'/club/:routeIdClub?'} element={<Club />} />
            <Route path={'/equipo/:routeIdEquipo?'} element={<Equipo />} />
            <Route path={'/partido/:routeIdPartido?'} element={<Partido />} />
            <Route path={'/lista/:routeIdLista?'} element={<Lista />} />
            <Route path={'/explorar/ligas'} element={<ExplorarLigas />} />
            <Route path={'/buscar'} element={<ExplorarLigas />} />
            <Route path={'/configuracion'} element={<Configuracion />} />
          </Route>
        </Routes>
      </ContextProvider>
    </Router>
  );
}

export default App;
